import { findExpressions } from './findExpressions'
import { substring } from '@the-platform-company/ts-utilities'

export const consolidateExpressions = (
  input: string,
  expressions = findExpressions(input)
) =>
  expressions.length
    ? expressions
        .reduce(
          (acc, [start, end], i, arr) => {
            // Add current expression
            acc.push(`(${substring(input, start, end)})`)

            if (arr[i + 1]) {
              // Current is not last
              if (end + 2 !== arr[i + 1][0] - 2) {
                //Next expression doesn't start immediately
                acc.push(
                  JSON.stringify(substring(input, end + 2, arr[i + 1][0] - 2))
                ) // Insert enclosing string
              }
            } else if (end !== input.length - 2) {
              //Last, but trailing string remains
              acc.push(JSON.stringify(substring(input, end + 2)))
            }

            return acc
          },
          // If expressions start immediately
          expressions[0][0] === 2
            ? // skip leading string part
              []
            : // else extract leading string
              [JSON.stringify(substring(input, 0, expressions[0][0] - 2))]
        )
        .join('&')
    : JSON.stringify(input)
